import { useSelector, useDispatch } from "react-redux";
import { useEffect, lazy, Suspense } from "react";
import { getPostAction, clearPostAction } from "../redux/actions/postActions";
import { getJoinedCommunitiesAction } from "../redux/actions/communityActions";
import { useParams } from "react-router-dom";
import CommonLoading from "../components/loader/CommonLoading";
import FallbackLoading from "../components/loader/FallbackLoading";
import ContentWithCards from "../components/shared/ContentWithCards";

const PostView = lazy(() => import("../components/post/PostView"));

const Post = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.auth?.userData);
  const post = useSelector((state) => state.posts?.post);

  // This page is intended for Mongo ObjectId posts only.
  // Route selection is handled by `PostOrProfile`, so slug should always be a valid ObjectId here.
  const isValidObjectId = /^[0-9a-fA-F]{24}$/.test(slug);

  // All hooks must be called before any conditional returns
  useEffect(() => {
    if (!isValidObjectId || !slug) {
      return;
    }
    
    dispatch(getPostAction(slug));
    
    // Only fetch authenticated data if user is logged in
    if (userData?._id) {
      dispatch(getJoinedCommunitiesAction());
    }

    return () => {
      dispatch(clearPostAction());
    };
  }, [dispatch, slug, isValidObjectId, userData?._id]);

  // (reserved for future authorization logic)

  // If not a valid ObjectId, show a simple not found state (should not happen in normal routing)
  if (!isValidObjectId) {
    return (
      <ContentWithCards>
        <div className="col-span-3 flex justify-center items-center h-screen">
          <div className="text-center text-gray-600">Post not found</div>
        </div>
      </ContentWithCards>
    );
  }

  if (!post) {
    return (
      <ContentWithCards>
        <div className="col-span-3 flex justify-center items-center h-screen">
          <CommonLoading />
        </div>
      </ContentWithCards>
    );
  }

  return (
    <ContentWithCards>
      <Suspense fallback={<FallbackLoading />}>
        <PostView post={post} userData={userData} />
      </Suspense>
    </ContentWithCards>
  );
};

export default Post;
